//@flow
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryRenderer } from 'react-relay';
import { IntlProvider } from 'react-intl';
//import QueryRenderer from 'relay-query-lookup-renderer';
import serverVars from 'server-vars';
import { UIDProvider } from 'dibs-uid';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../relayModernEnvironment';
import { defaultLocale } from 'dibs-intl/exports/constants';

import { InteriorPhotoWrapper } from '../interiorsPhoto/InteriorPhotoWrapper';
import { PhotoRootQuery } from '../interiorsPhoto/PhotoRootQuery';

const locale = serverVars.get('locale');
const messages = serverVars.get('messages');
const photoPath = serverVars.get('photoPath');
const variables = serverVars.get('relayVariables');
const environment = getEnvironment(true);

initializeDBL().then(() => {
    const interiorPhotoDOMNode = document.getElementById('js-root');

    if (interiorPhotoDOMNode !== null) {
        ReactDOM.hydrate(
            <UIDProvider>
                <IntlProvider locale={locale} messages={messages} defaultLocale={defaultLocale}>
                    <QueryRenderer
                        environment={environment}
                        query={PhotoRootQuery}
                        variables={variables}
                        fetchPolicy="store-or-network"
                        render={({ props, error }) => {
                            // TODO loading state
                            if (error) {
                                console.error('error!', error);
                                // TODO error state
                                return null;
                            }

                            const viewer = (props && props.viewer) || null;

                            return (
                                <InteriorPhotoWrapper
                                    viewer={viewer}
                                    initialLookupUrl={photoPath}
                                />
                            );
                        }}
                    />
                </IntlProvider>
            </UIDProvider>,
            interiorPhotoDOMNode
        );
    }
});
